import {AnonymusRequest } from "./HttpService";
import FileService from "./FileService";
import { translateAndSortAscendant } from "../common/helper";
export const AnonymusDocOnlineService = {
    getAllJobRoles: function () {
      return AnonymusRequest("doconline/DOCPersonalInformation/GetAllJobRoles", "GET").then((data)=>{
        return translateAndSortAscendant (data, "description");
      });
    },
  
    getlAllLanguages: function () {
      return AnonymusRequest("doconline/DOCEducation/Language", "GET").then((data)=>{
        return translateAndSortAscendant (data, "description");
      });
    },
  
    getlAllZonesByCompany: function (companyId) {
      let url = `doconline/DOCPersonalInformation/GetAllZonesByCompany/${companyId}`;
      return AnonymusRequest(url, "GET");
    },
  
    getAllLanguageLevels: function () {
      return AnonymusRequest("doconline/DOCEducation/LanguageLevel", "GET").then((data)=>{
        return translateAndSortAscendant (data, "description");
      });
    },
  
    getCourses: function (pageSize, pageNumber, searchData) {
      let url = `doconline/DOCEducation/SearchCourses/${pageSize}/${pageNumber}`;
      if (searchData !== undefined) {
        url = url + `?query=${searchData}`;
      }
      return AnonymusRequest(url, "GET");
    },
  
    getSchools: function (pageSize, pageNumber, searchData) {
      let url = `doconline/DOCEducation/SearchSchools/${pageSize}/${pageNumber}`;
      if (searchData !== undefined) {
        url = url + `?query=${searchData}`;
      }
      return AnonymusRequest(url, "GET");
    },
  
    getDocOnlineByToken: function (token) {
      let url = `doconline/DOCGeneral/${token}`;
      return new Promise((resolve, reject) => {
        AnonymusRequest(url, "GET", null, (err) => {
          console.error(err);
          reject(err);
        }).then((data) => {
          resolve(data);
        });
      });
    },
  
    getDocOnlineRGPD: function (companyId, generatedLanguageInitials) {
      let url = `doconline/DOCGeneral/GetRGPD/${companyId}/${generatedLanguageInitials}`;
      return new Promise((resolve, reject) => {
        AnonymusRequest(url, "GET", null, (err) => {
          console.error(err);
          reject(err);
        }).then((data) => {
          resolve(data);
        });
      });
    },
  
    getDocOnlinePrivacyPolicy: function (companyId, generatedLanguageInitials) {
      let url = `doconline/DOCGeneral/GetPrivacyPolicy/${companyId}/${generatedLanguageInitials}`;
      return new Promise((resolve, reject) => {
        AnonymusRequest(url, "GET", null, (err) => {
          console.error(err);
          reject(err);
        }).then((data) => {
          resolve(data);
        });
      });
    },
  
    AcceptRGPD: function (token) {
      let url = "doconline/DOCGeneral/AcceptRGPD";
      return AnonymusRequest(url, "PUT", token);
    },
  
    Submit: function (docOnline) {
      let url = "doconline/DOCGeneral/Submit";
      return AnonymusRequest(url, "PUT", docOnline);
    },
    GetAllSkillLevels() {
      let url = "doconline/DOCSkillLevel";
      return AnonymusRequest(url, "GET");
    },
    getAllYearsExperience() {
      return AnonymusRequest("doconline/DOCSkillExperienceTime", "GET");
    },
    getTechSkills(companyId) {
      return AnonymusRequest(`doconline/DocTechnology/${companyId}/`, "GET").then((data)=>{
        return translateAndSortAscendant (data, "description");
      });
    },
    getDocOnlineById: function (docOnlineId) {
      let url = `vitae/EditDocOnline/GetById/${docOnlineId}`;
      return new Promise((resolve, reject) => {
        AnonymusRequest(url, "GET", null, (err) => {
          console.error(err);
          reject(err);
        }).then((data) => {
          resolve(data);
        });
      });
    },
    EditDocOnline: function (docOnline,interviewId, docOnlineLanguageId) {
      let url = "vitae/EditDocOnline/Save";
      if (interviewId) {
        url = `vitae/EditDocOnline/Save/${docOnlineLanguageId}/${interviewId}`;
      }
      return AnonymusRequest(url, "PUT", docOnline);
    },
    SaveAsDocOnline: function (docOnline) {
      let url = "vitae/EditDocOnline/SaveAs";
      
      return AnonymusRequest(url, "PUT", docOnline);
    },
    DownloadDocOnline: function (
      docOnlineId,
      companyId,
      languageId,
      downloadIsInPdf,
      fileName,
      openInNewTab
    ) {
      let url = `vitae/EditDocOnline/Download/${docOnlineId}/${companyId}/${languageId}/${downloadIsInPdf}`;
      return FileService.Download(url, fileName, openInNewTab);
    },
    generateUrl(docOnlineId,langCode,companyId){
   let url=""
      if(!companyId)
    url = `doconline/documents/GenerateSharedURl/${langCode}/${docOnlineId}`
    else
    url = `doconline/documents/GenerateSharedURl/${langCode}/${companyId}/${docOnlineId}`
      return  AnonymusRequest(url,"GET");
    },
    hasWebView()
    {
      return AnonymusRequest("doconline/documents/webview","GET")
    },
    getAllTemplates(){
      return AnonymusRequest("vitae/EditDocOnline/template","GET")
    }
   
  };